import { Endowment as Domain, EndowmentField } from 'modules/cm/RepaymentStrategy/Endowment';
import { format } from 'utils/date';
import { Endowment as API } from '../Endowment';

const apiBuilder = (domain: Partial<Domain>) => {
  const api: Partial<API> = {};

  return {
    add(fields: EndowmentField[]): void {
      const map = new Map([
        [
          EndowmentField.CurrentFundValue,
          () => {
            api.currentFundValue = domain[EndowmentField.CurrentFundValue];
          },
        ],
        [
          EndowmentField.ExpectedMaturityDate,
          () => {
            const date = domain[EndowmentField.ExpectedMaturityDate];
            api.expectedMaturityDate = date ? format(date).fromViewToRequest() : null;
          },
        ],
        [
          EndowmentField.MonthlyContribution,
          () => {
            api.monthlyContribution = domain[EndowmentField.MonthlyContribution];
          },
        ],
        [
          EndowmentField.Provider,
          () => {
            api.provider = domain[EndowmentField.Provider];
          },
        ],
      ]);

      fields.forEach((field) => {
        const adder = map.get(field);
        if (typeof adder === 'function') {
          adder();
        }
      });
    },
    getAPI() {
      return api;
    },
  };
};

export const mapPartialDomainToPartialApi = (domain: Partial<Domain>): Partial<API> => {
  const builder = apiBuilder(domain);
  builder.add(Object.keys(domain) as EndowmentField[]);

  return builder.getAPI();
};

const mapDomainToAPI = (domain: Domain): API => {
  const builder = apiBuilder(domain);
  builder.add(Object.keys(domain) as EndowmentField[]);

  return builder.getAPI() as API;
};

export const mapEndowmentToApi = (domain: any): API => ({
  id: domain[EndowmentField.Id],
  provider: domain[EndowmentField.Provider],
  expectedMaturityDate: domain[EndowmentField.ExpectedMaturityDate],
  currentFundValue: domain[EndowmentField.CurrentFundValue],
  monthlyContribution: domain[EndowmentField.MonthlyContribution],
});

export default mapDomainToAPI;
